<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      :expand-config="{ reserve: true }"
      resizable
      border
      show-footer
      :footer-method="footerMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <!--设置插槽内的表格宽度-->
        <div class="m-2">
          <batch-goods-table
            :disabled="disabled"
            :orderBatchCode="row.orderBatchCode"
            :changeOrderCode="row.changeOrderCode"
          />
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  params: row,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  params: row,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.changeOrderBatchCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'copy',
                  params: row,
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import BatchGoodsTable from '../batch-goods-table/index.vue'
import Math from '@/libs/util.math.js'
export default {
  mixins: [TableAutoHeight],
  components: { BatchGoodsTable },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = Math.add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns.map(
        (t) => totalColumnValues[t.field] || ''
      )
      result[0] = '合计'

      return [result]
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          type: 'checkbox',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 150,
          slots: {
            default: 'opt',
          },
        },
        {
          type: 'expand',
          width: 70,
          align: 'center',
          title: this.$l('INDEX.form_label_expand') || '展开',
          slots: {
            content: 'expandContent',
          },
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_orderBatchNo') ||
            '交货批次号',
          field: 'orderBatchNo',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.order_form_label_retailerPo') || '零售商PO',
          field: 'retailerPo',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.order_form_label_importerPo') || '代理商PO',
          field: 'importerPo',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_identifyNo') ||
            '批次识别单号',
          field: 'identifyNo',
          headerAlign: 'center',
          align: 'left',
          minWidth: 180,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.form_label_brand') || '品牌',
          field: 'brandName',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.batch_label_deliveryDate') || '工厂交期',
          field: 'deliveryDate',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_shipmentDate') || '客户交期',
          field: 'shipmentDate',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_shipmentEndDate') ||
            '客户交期截止日期',
          field: 'shipmentEndDate',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.table_label_cargoReadyDay') || '货好时间',
          field: 'cargoReadyDay',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.order_form_batch_label_totQty') || '产品数',
          field: 'totQty',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'number',
          isTotalColumn: true,
        },
        {
          title: this.$l('INDEX.order_form_batch_label_totBoxQty') || '箱数',
          field: 'totBoxQty',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'number',
          isTotalColumn: true,
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_packingType') || '装箱方式',
          field: 'v_packingType',
          headerAlign: 'center',
          align: 'center',
          minWidth: 90,
          showHeaderOverflow: true,
          showOverflow: true,
          // sortable: true,
          // sortType: 'string'
        },
        {
          title: this.$l('INDEX.order_form_label_materialSpec') || '包装规格',
          field: 'materialSpec',
          headerAlign: 'center',
          align: 'center',
          minWidth: 140,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.batch_label_deliveryType') || '出货方式',
          field: 'deliveryType',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.batch_label_outBillType') || '出单类型',
          field: 'outBillType',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_dispatchPort') || '发运港口',
          field: 'dispatchPort',
          headerAlign: 'center',
          align: 'center',
          minWidth: 130,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_destinationPort') ||
            '目的港口',
          field: 'destinationPort',
          headerAlign: 'center',
          align: 'center',
          minWidth: 130,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.batch_label_receiver') || '收货人',
          field: 'receiver',
          headerAlign: 'center',
          align: 'left',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.batch_label_receiverPhone') || '联系电话',
          field: 'receiverPhone',
          headerAlign: 'center',
          align: 'left',
          minWidth: 140,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.batch_label_receiverAddress') || '收货地址',
          field: 'receiverAddress',
          headerAlign: 'center',
          align: 'left',
          minWidth: 200,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        // {
        //   title: this.$l('INDEX.table_label_modified_by') || '修改人姓名',
        //   field: 'modifyByName',
        //   align: 'center',
        //   minWidth: 120,
        //   showHeaderOverflow: true,
        //   showOverflow: true,
        // },
        // {
        //   title: this.$l('INDEX.table_label_modification_date') || '修改时间',
        //   field: 'modifyTime',
        //   align: 'center',
        //   minWidth: 170,
        //   showHeaderOverflow: true,
        //   showOverflow: true,
        // },
      ],
    }
  },
  methods: {
    footerMethod() {
      // 返回一个二维数组的表尾合计
      return this.footerData
    },
    //单行删除
    del(code) {
      this.$emit('batchDel', [code])
    },
    //批量删除前的验证
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }

      if (data.length > 20) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_max_select_rows') ||
            '最多可选择20行！',
          type: 'warning',
        })
        return
      }

      if (type === 'code') {
        return data.map((row) => {
          return row.changeOrderBatchCode
        })
      }
      return data
    },
    add(x, y) {
      x = x || 0
      y = y || 0
      return Math.number(Math.add(Math.bignumber(x), Math.bignumber(y)))
    },
  },
}
</script>
